module.exports = __webpack_public_path__ + "static/media/15-iveco.00551fa7.jpg";